import httpService from './httpService';
import {
  CreateIntroductionBody,
  FilterConnectedIntroducedRequest,
  FilterConnectedIntroducedResponse,
  IntroductionResponseBody,
} from '../models/introductionService.model';

function getCompatibleUserids(toIntroduceUserId: number, otherUserIds: number[]): Promise<number[]> {
  const body: FilterConnectedIntroducedRequest = { toIntoduceUserId: toIntroduceUserId, otherUserIds };
  return httpService
    .post<FilterConnectedIntroducedResponse>(`/introductions/check-validity`, body)
    .then(({ data }) => data.notConnectedNotIntroducedUserIds);
}

function createIntroductions(introducedId: number, userIds: number[]): Promise<number[]> {
  const intros: CreateIntroductionBody[] = userIds.map((id) => ({
    userIdA: introducedId,
    userIdB: id,
  }));
  return httpService
    .post<IntroductionResponseBody[]>('/introductions', intros)
    .then(({ data }) => data.map((i) => i.userIdB));
}

const introductionService = {
  getCompatibleUserids,
  createIntroductions,
};

export default introductionService;
